import React, { useState } from 'react'

import { BottomSheet, colors as zetColors } from '@zet/design-system'
import { Icon } from '@zet/design-system/icons'
import { Input } from '@zet/design-system/input'
import { Stack, XStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { Select } from '@zet/design-system/select'
import { SH1 } from '@zet/design-system/typography'

const Dropdown = ({
  label = 'Select Dropdown',
  dropdownMode = 'single',
  isSearchable = true,
  onDismiss,
  selectedValue,
  onSelect,
  setDropDownVisible,
  dropDownVisible,
  options,
  fieldId,
}) => {
  const [searchedValue, setSearchedValue] = useState('')

  function selectValue(value: string, displayText: string) {
    setDropDownVisible(false)
    onSelect(value, displayText)
  }

  return (
    <Stack>
      <BottomSheet visible={dropDownVisible} onDismiss={onDismiss}>
        <>
          <Stack>
            <XStack className="border-grays-30 justify-between border-b px-3 py-2 ">
              <XStack className="items-center ">
                <Icon type="WorkOutlined" size={24} />
                <SH1
                  className=" ml-[12] truncate"
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  style={{ width: 220 }}
                >
                  {label}
                </SH1>
              </XStack>
              <Pressable onPress={() => setDropDownVisible(false)}>
                <Icon size={24} type="Close" />
              </Pressable>
            </XStack>
            {isSearchable ? (
              <Stack className="mx-3 mt-2">
                <Input
                  placeholder={'search'}
                  onChangeText={(text) => {
                    setSearchedValue(text)
                  }}
                  autoCapitalize={'none'}
                  spellCheck={false}
                  // keyboardType="number-pad"
                  // iconLeft={<Icon type="LocationOutlined" />}
                />
              </Stack>
            ) : (
              <></>
            )}
          </Stack>
          <Stack className="px-3 pb-3">
            <Stack className="">
              <Select
                value={selectedValue}
                mode={dropdownMode}
                onChange={selectValue}
              >
                {(isSearchable ? data?.results.slice(0, 20) : options)?.map(
                  ({ optionValue, optionId }) => (
                    <Select.Option
                      key={optionId}
                      name={optionValue}
                      displayText={optionValue}
                      selectedValue={selectedValue}
                      optionContainerStyle="h-6 mt-3 w-full justify-center rounded-lg"
                      showToggle={dropdownMode === 'single' ? false : true}
                      iconColor={{
                        active: zetColors.primary[50],
                        inActive: zetColors.grays[60],
                      }}
                    >
                      <SH1>{optionValue}</SH1>
                    </Select.Option>
                  )
                )}
              </Select>
            </Stack>
          </Stack>
        </>
      </BottomSheet>
    </Stack>
  )
}

export default Dropdown
